import { HARISENIN_PUBLIC_PAGE_ASSETS } from "@constants/const/pictures"
import Image from "next/image"
import { Modal } from "../../../components/modal/Modal"

interface modalInterface {
  show: boolean
  onClose: any
}

export const SuccessModal = ({ show, onClose }: modalInterface) => {
  return (
    <Modal show={show} onClose={onClose} contentClassName="!p-0 lg:w-[30%]">
      <div className="absolute right-4 top-2 text-2xl cursor-pointer sm-only:hidden" onClick={onClose}>
        x
      </div>
      <div className="p-8">
        <div className="flex align-center w-full rounded-lg relative">
          <Image
            loading="lazy"
            src={`${HARISENIN_PUBLIC_PAGE_ASSETS}/corporate_popup.png`}
            alt="banner-1"
            width={360}
            height={360}
            className="cover mx-auto fade_in_left border-2 border-white"
          />
        </div>
        <div className="pt-5 font-semibold text-center text-2xl">Terima Kasih!</div>
        <p className="text-black-67 text-center my-2">
          Tim Harisenin akan segera menghubungi untuk mendiskusikan layanan Corporate Training yang
          Anda butuhkan.
        </p>
      </div>
    </Modal>
  )
}
